import { SettingConst } from '../../types';

/**
 * Optimizes various performance aspects of web-retailer
 */
export const MILLION_LINT_OPTIMIZATION_241118 =
  'MILLION_LINT_OPTIMIZATION_241118' as SettingConst<
    'MILLION_LINT_OPTIMIZATION_241118',
    boolean,
    'RETAILER'
  >;
